/* LAFUHQE Answer-First: auto table of contents from H2s in the article body.
   Install: theme/assets/aeo-toc.js (loaded by main-article.liquid). */
document.addEventListener('DOMContentLoaded', function () {
  var body = document.getElementById('aeo-body');
  var toc = document.getElementById('aeo-toc');
  if (!body || !toc) return;
  var hs = body.querySelectorAll('h2');
  if (hs.length < 2) { toc.remove(); return; }
  var heading = document.createElement('p');
  heading.className = 'aeo-toc__title';
  heading.textContent = 'On this page';
  toc.appendChild(heading);
  var ul = document.createElement('ul');
  hs.forEach(function (h, i) {
    var id = h.id || 'sec-' + i;
    h.id = id;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = h.textContent;
    li.appendChild(a);
    ul.appendChild(li);
  });
  toc.appendChild(ul);
});
